// extracted by mini-css-extract-plugin
module.exports = {"container":"az_SZb","contentContainer":"az_TZb","linkButton":"az_UZb","heading":"az_VZb","description":"az_WZb"};